import "@/App.css";
import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/staysy/Header";
import Hero from "@/components/staysy/Hero";
import Features from "@/components/staysy/Features";
import Showcase from "@/components/staysy/Showcase";
import Pricing from "@/components/staysy/Pricing";
import FAQ from "@/components/staysy/FAQ";
import CTA from "@/components/staysy/CTA";
import Footer from "@/components/staysy/Footer";
import OnboardingModal from "@/components/staysy/OnboardingModal";

function Landing() {
  const [modalOpen, setModalOpen] = useState(false);
  const [prefillEmail, setPrefillEmail] = useState("");

  const openModal = (email = "") => {
    setPrefillEmail(typeof email === "string" ? email : "");
    setModalOpen(true);
  };

  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#FDFBF7]">
      <Header onOpenModal={openModal} />
      <main>
        <Hero onOpenModal={openModal} />
        <Features />
        <Showcase />
        <Pricing onOpenModal={openModal} />
        <FAQ />
        <CTA onOpenModal={openModal} />
      </main>
      <Footer />
      <Toaster position="top-center" richColors />
      <OnboardingModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        prefillEmail={prefillEmail}
      />
    </div>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}
